import React, {useEffect, useState} from "react";
import {
  Backdrop, Box,
  Button, capitalize,
  Card, Chip,
  CircularProgress, Collapse,
  Container, FormControl, InputLabel, MenuItem, Select,
  Snackbar,
  Stack, TextareaAutosize,
  TextField,
  Typography
} from "@mui/material";
import {useNavigate, useParams} from "react-router-dom";
import axios from "axios";
import {API_URL, THEME_CONFIG, TOOLPRESS_API} from "../../../config";
import {firebase} from "../../../firebase/clientApp";

export default function ToolpressQuestion({elementPlaying}) {
  const {primary,} = THEME_CONFIG

  const {eventOwnerId, id} = useParams()
  const [fields, setFields] = useState([])
  let navigate = useNavigate()
  const [values, setValues] = useState({
    domanda: '',
    'Session': null
  })
  const [loading, setLoading] = useState(true)
  const [success, setSuccess] = useState(false)
  const [sending, setSending] = useState(false)
  const [error, setError] = useState(false)
  const [open, setOpen] = useState(false)
  const [userData, setUserData] = useState({displayName: ''})
  const [selectedSession, setSelectedSession] = useState(null)

  useEffect(async () => {
    setLoading(true)
    firebase.auth().onAuthStateChanged(async (user) => {
      await axios.post(`${API_URL}users/${eventOwnerId}/events/${id}/users`, {user: user.uid})
        .then(res =>
          setUserData({displayName: res.data.displayName ?? ''})
        )
        .catch()
    })
    setLoading(false)
  }, [])

  useEffect(() => {
    axios.get(`${TOOLPRESS_API}/conference/${elementPlaying.conferenza}/columns`)
      .then(response => {
        const obj = {}
        setFields(response.data)
        response.data.map(r => obj[r] = '')
        setValues({...values, ...obj})
        setLoading(false)
      })
      .catch(() => {

      })
  }, [])

  const handleChangeValue = (key, value) => {
    setValues({...values, [key]: value})
  }

  useEffect(() => {
    handleChangeValue("Session", selectedSession ? `Session ${selectedSession}` : null)
  }, [selectedSession])

  const postQuestions = async () => {
    setSending(true)
    await axios.post(`${TOOLPRESS_API}/question/${elementPlaying.conferenza}`, {
      question: {
        ...values,
        nickname: userData?.displayName || ''
      }
    })
    setSending(false)
    setValues(prevState => ({...prevState, domanda: '',}))
  }


  const sendQuestion = (e) => {
    e.preventDefault()

    postQuestions()
      .then(() => {
        setSuccess(true)
        setOpen(true)
        setTimeout(() => setOpen(false), 5000)
      })
      .catch(() => setError(true))

  }

  return (
    <Box>
      <Backdrop
        sx={{color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1}}
        open={loading || sending}
      >
        <CircularProgress color="inherit"/>
      </Backdrop>
      <form style={{padding: '1rem 1rem', textAlign: 'left'}} onSubmit={sendQuestion}>
        <Stack direction={"column"} spacing={2}>
          {/*fields.map(f =>
                        <Box>
                            <TextField sx={{width: '100%'}} variant={"standard"}
                                       label={capitalize(f)}
                                       required
                                       value={values[f]} onChange={(e) => handleChangeValue(e, f)}
                            />
                        </Box>
                    )*/}
          {/*<FormControl fullWidth required>
            <InputLabel id="demo-simple-select-label">Choose a session</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={values['Session']}
              label="Choose a session"
              sx={{borderRadius: '18px 0', border: '2px solid ' + 'rgba(255,255,255,0.2)'}}
              onChange={(e) => handleChangeValue('Session', e.target.value)}
            >
              {
                [1, 2, 3, 4, 5, 6, 7, 8].map((session, index) => {
                  return <MenuItem value={'Session ' + (index + 1)}>Session {index + 1}</MenuItem>
                })
              }
            </Select>
          </FormControl>*/}
          {<Stack>
            <Typography gutterBottom variant={'body2'} textAlign={'center'} textTransform={"uppercase"} fontWeight={"bold"}>Choose a
              session *</Typography>
            <Stack pb={2} direction={"row"} flexWrap={"wrap"} justifyContent={"space-evenly"}>
              {
                ["1 - Panel su questo tema", "2 - Panel su quest'altro tema", "3 - Bello questo panel", "4 - Panel su quest'altro tema", "5 - Bello questo panel", "6 - Panel su quest'altro tema", "7 - Bello questo panel", "8 - Bello questo panel"]
                  .map((session, index) => {
                    return <Box sx={{
                      borderRadius: '18px 0',
                      mt: 1,
                      mr: 1,
                      minWidth: '20%',
                      padding: 1,
                      backgroundColor: selectedSession === (index + 1) ? primary : '',
                      border: '2px solid ' + primary,
                    }}
                                id={'Session ' + (index + 1)}
                                children={<Typography
                                  fontWeight={'bold'}
                                  textAlign={'center'}
                                  color={selectedSession === (index + 1) ? 'white' : 'rgba(255,255,255,0.5)'}>
                                  {index + 1}</Typography>}
                                onClick={() => {
                                  if (index + 1 !== selectedSession) {
                                    setSelectedSession(index + 1)
                                  } else {
                                    setSelectedSession(null)
                                  }
                                }}/>
                  })
              }
            </Stack>
          </Stack>}
          <Box sx={{display: 'flex', width: '100%', justifyContent: 'center', alignItems: 'center'}}>
            <TextField
              required
              style={{width: '100%'}}
              fullWidth
              label={'Write your question here...'}
              variant={"outlined"}
              onChange={(e) => handleChangeValue('domanda', e.target.value)}
              value={values['domanda']}
              multiline
              minRows={4}
            />
          </Box>
          <Box sx={{textAlign: 'center'}}>
            <Button sx={{my: 2}} variant={"default"} disabled={!values.domanda || !values.Session} type={'submit'}
                    fullWidth>
              {success ? "Submit" : 'Submit'}
            </Button>
          </Box>
        </Stack>
      </form>
      <Collapse in={open}>
        <Typography>
          Success!
        </Typography>
      </Collapse>
    </Box>
  )
}
